import React from 'react';
import styled, { keyframes } from 'styled-components';


const cool = keyframes`
  from {
    background-size: 3px 15px;
  }
  to {
    background-size: 10px 5px;
  }
`;

const gradientAnimation = keyframes`
  from {
    background-position: 0 0, 0 0, 40px 70px, 40px 70px, 0 0, 40px 70px;
  }
  to {
    background-position: 0 0, 0 0, 10px 10px, 9px 20px, 0 0, 10px 20px;
  }
`;

const NotFoundContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  background: radial-gradient(circle at 100% 150%, rgb(0, 0, 0) 24%, #FFFFFF 25%, #FFFFFF 28%, rgb(0, 0, 0) 29%, rgb(76, 76, 76) 36%, #FFFFFF 36%, #FFFFFF 40%, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0) 100%), 
            radial-gradient(circle at 0 150%, rgb(0, 0, 0) 24%, #FFFFFF 25%, #FFFFFF 28%, rgb(0, 0, 0) 29%, rgb(76, 76, 76) 36%, #FFFFFF 36%, #FFFFFF 40%, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0) 100%), 
            radial-gradient(circle at 50% 100%, #FFFFFF 10%, rgb(76, 76, 76) 11%, rgb(76, 76, 76) 23%, #FFFFFF 24%, #FFFFFF 30%, rgb(76, 76, 76) 31%, rgb(76, 76, 76) 43%, #FFFFFF 44%, #FFFFFF 50%, rgb(0, 0, 0) 51%, rgb(76, 76, 76) 63%, #FFFFFF 64%, #FFFFFF 71%, rgba(0, 0, 0, 0) 71%, rgba(0, 0, 0, 0) 100%), 
            radial-gradient(circle at 100% 50%, #FFFFFF 5%, rgb(76, 76, 76) 6%, rgb(76, 76, 76) 15%, #FFFFFF 16%, #FFFFFF 20%, rgb(76, 76, 76) 21%, rgb(76, 76, 76) 30%, #FFFFFF 31%, #FFFFFF 35%, rgb(76, 76, 76) 36%, rgb(76, 76, 76) 45%, #FFFFFF 46%, #FFFFFF 49%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%), 
            radial-gradient(circle at 0 50%, #FFFFFF 5%, rgb(76, 76, 76) 6%, rgb(76, 76, 76) 15%, #FFFFFF 16%, #FFFFFF 20%, rgb(76, 76, 76) 21%, rgb(76, 76, 76) 30%, #FFFFFF 31%, #FFFFFF 35%, rgb(76, 76, 76) 36%, rgb(76, 76, 76) 45%, #FFFFFF 46%, #FFFFFF 49%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%), rgb(76, 76, 76);

-webkit-background-origin: padding-box;
background-origin: padding-box;
-webkit-background-clip: border-box;
background-clip: border-box;
background-size: 10px 5px;
animation: ${cool} 9s linear infinite;
`;




const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
`;

const fadeInOut = keyframes`
  0%, 100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
`;

const AnimationContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;
  padding: 20px;
  & > div {
    position: absolute;
    border: 2px solid white;
    border-radius: 50%;
    clip-path: circle(50%);
  }

  .rotate {
    height: 150px;
    animation: ${rotate} 5s linear infinite;
  }

  .pulse {
    width: 100px;
    animation: ${pulse} 2s ease-in-out infinite;
  }

  .fadeInOut {
    width: 200px;
    height: 200px;
    animation: ${fadeInOut} 4s ease-in-out infinite;
  }
`;

const TextContainer = styled.div`
  z-index: 1;
  margin-bottom: 20px;
  h1 {
    font-size: 4rem;
    margin: 0;
  }

  p {
    font-size: 1.5rem;
    margin: 0;
  }
`;

const Loading = () => {
  return (
    <NotFoundContainer>
      <AnimationContainer>
        <div className="rotate" />
        <div className="pulse" />
        <div className="fadeInOut" />
      </AnimationContainer>
      <TextContainer>
        <h1>LOADING...</h1>
        <p>Relajate chico</p>
      </TextContainer>
    </NotFoundContainer>
  );
};

export default Loading;
